import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "walden-fast/templates/app/manage/subscriptions/index.hbs" })